<script>
import DinoPet from "./DinoPet";

export default {
  props: {
    petName: {
      type: String,
      required: true
    },
    petMood: {
      type: String,
      required: true
    }
  },
  components: {
    DinoPet
  }
};
</script>

<template>
  <div :class="$style.wrapper">
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 364 476"
      :class="$style.gigavue"
    >
      <g id="Page-1">
        <g id="tamagotchi">
          <path
            id="Shape"
            d="M206,51.57a31,31,0,1,0-48,0C67.73,70.29.68,191.45.68,296.93.68,405.1,71.84,475,182,475s181.31-69.9,181.31-178.07C363.31,191.45,296.26,70.29,206,51.57ZM165,32a17,17,0,1,1,17,17A17,17,0,0,1,165,32Zm17,31c80.5,0,145.52,91.78,162.77,186l-30.25-14.59a7,7,0,0,0-7.2.67l-15,11.07-16-3.24v-72.7a7,7,0,0,0-7-7H94.67a7,7,0,0,0-7,7v72.7l-16,3.24-15-11.07a7,7,0,0,0-7.2-.67L19.24,248.94C36.5,154.76,101.51,63,182,63ZM101.67,248.78v-71.6H262.33v127H101.67ZM182,461c-80.88,0-167.31-43.1-167.31-164.07a258.25,258.25,0,0,1,2-31.2L51.72,248.8l14.12,10.42a7,7,0,0,0,5.55,1.22l16.28-3.29v54a7,7,0,0,0,7,7H269.33a7,7,0,0,0,7-7v-54l16.28,3.29a7,7,0,0,0,5.55-1.22l14.08-10.4,35.13,16.95a259.46,259.46,0,0,1,1.94,31.15C349.31,417.9,262.88,461,182,461Z"
          />
          <polygon
            id="Path"
            :class="$style.white"
            points="100.67 248.78 100.67 177.18 261.33 177.18 261.33 304.16 100.67 304.16 100.67 248.78"
          />
          <path
            id="Combined-Shape"
            :class="$style.blue"
            d="M182,63c80.49,0,145.52,91.78,162.77,186h0l-30.24-14.59a7,7,0,0,0-7.2.67l-15,11.07-16-3.24v-72.7a7,7,0,0,0-7-7H94.67a7,7,0,0,0-7,7v72.7l-16,3.24-15-11.07a7,7,0,0,0-7.2-.67L19.24,248.94C36.5,154.76,101.51,63,182,63Z"
          />
          <path
            id="Combined-Shape-2"
            data-name="Combined-Shape"
            :class="$style.green"
            d="M312.55,249l34.82,16.8a259.46,259.46,0,0,1,1.94,31.15C349.31,417.9,262.88,461,182,461S14.69,417.9,14.69,296.93a258.25,258.25,0,0,1,2-31.2L51.38,249h.56l13.9,10.25a7,7,0,0,0,5.55,1.22l16.28-3.29v54a7,7,0,0,0,7,7H269.33a7,7,0,0,0,7-7v-54l16.28,3.29a7,7,0,0,0,5.55-1.22L312,249Z"
          />
          <path
            id="Path-2"
            data-name="Path"
            d="M332.31,289.93a7,7,0,0,0-7,7A173,173,0,0,1,318,348.67a7,7,0,0,0,4.58,8.77,6.53,6.53,0,0,0,2.1.32,7,7,0,0,0,6.67-4.9,186.51,186.51,0,0,0,8-55.93,7,7,0,0,0-7-7Z"
          />
          <path
            id="Shape-2"
            data-name="Shape"
            d="M243.5,362.33a19,19,0,1,0,19,19,19,19,0,0,0-19-19Zm0,24a5,5,0,1,1,5-5A5,5,0,0,1,243.5,386.33Z"
          />
          <path
            id="Shape-3"
            data-name="Shape"
            d="M182,384a19,19,0,1,0,19,19,19,19,0,0,0-19-19Zm0,24a5,5,0,1,1,5-5,5,5,0,0,1-5,5Z"
          />
          <path
            id="Shape-4"
            data-name="Shape"
            d="M120.5,362.33a19,19,0,1,0,19,19A19,19,0,0,0,120.5,362.33Zm0,24a5,5,0,1,1,5-5,5,5,0,0,1-5,5Z"
          />
        </g>
      </g>
    </svg>
    <DinoPet v-if="petName" :class="$style.dinopet" :mood="petMood" />
  </div>
</template>

<style lang="scss" module>
.gigavue {
  max-width: 400px;
  width: 100%;
}

.white {
  fill: #fff;
}

.blue {
  fill: #34495e;
}

.green {
  fill: #41b883;
}

.wrapper {
  position: relative;
  display: flex;
  justify-content: center;
}

.dinopet {
  position: absolute;
  max-width: 120px;
  width: 100%;
  top: 50%;
  transform: translateY(-45%);
  z-index: 1;
}
</style>
